import { FormsMultilineInput, Spinner } from '@platform/components';
import { Control, FormState } from 'react-hook-form';
import { UpdateDiscoveryCallFormData } from '.';

type ProConfirmMatchProps = {
  isSaving: boolean;
  control: Control<UpdateDiscoveryCallFormData>;
  formState: FormState<UpdateDiscoveryCallFormData>;
};

export const ProConfirmMatch = (props: ProConfirmMatchProps) => {
  return (
    <div className='flex flex-col gap-4 md:mt-8 md:w-[500px]'>
      {props.isSaving ?
        <div className='flex justify-center'>
          <Spinner />
        </div>
      : <div className='w-full items-stretch flex flex-col gap-8'>
          <h3 className='text-lg font-semibold text-center'>Ready to confirm your match?</h3>
          <div className='text-lg text-center'>
            By confirming this match, we will decline your other pending introductions and
            connections on your behalf. You can find them in the Inactive tab under My Projects.
          </div>
          <div>
            <div className='text-sm'>
              Anything you'd like to share with the MovingWorlds team? (optional)
            </div>
            <FormsMultilineInput
              control={props.control}
              name='additionalDetails'
              placeholder='Enter details'
              characterCount={500}
              formsError={props.formState.errors['additionalDetails']}
            />
          </div>
        </div>
      }
    </div>
  );
};
